(function ($, config) {

	//shortcut
	const log = (...data) => {
		if (config.debug) {
			if (data.length === 1)
				console.log(data[0]);
			else if (data.length === 2)
				console.log(data[0], data[1]);
			else if (data.length === 3)
				console.log(data[0], data[1], data[2]);
			else if (data.length === 4)
				console.log(data[0], data[1], data[2], data[3]);
			else if (data.length === 4)
				console.log(data[0], data[1], data[2], data[3], data[4]);
			else
				console.log(data[0], data);
		}
	};

	const $root = $('#event-subscribe');

	const eventId = $root.find('#event_id').val();

	const $menuList = $root.find('#event-subscribe-menu a');
	const $form = $root.find('#event-subscribe-form');
	if (!$form.length) {
		return;
	}
	const $formMultiTypeAnonymous = $form.find('[name="multi-type-anonymous"]');
	const $formMultiAnonymousPrice = $form.find('input[name="multi-anonymous-price"]');
	const $formIndPrice = $form.find('input[name="ind-price"]');
	const $multiMemberQty = $root.find('#multi-members-qty');
	const alreadyRegistred = $root.attr('data-already-registred');

	const def_typeMulti = 'multi';
	const def_typeMultiSimple = 'simple';
	const def_typeMultiAnonymous = 'anonymous';
	const def_typeInd = 'ind';

	/**
	 * Calc prices
	 */
	const calculate_price = () => {
		const $totalPrice = $root.find('.price-total, .legal-copy');
		let price = 0.0;
		let formValid = true;
		if ($form.attr('data-type') === def_typeMulti) {
			const qty = Number.parseInt($multiMemberQty.val(), 10);
			if ($form.attr('data-multi-type') === def_typeMultiAnonymous) {
				const priceUnit = Number.parseFloat($formMultiAnonymousPrice.filter(':checked').attr('data-price'));
				price = qty * priceUnit;
			} else {
				$root.find('fieldset.members-participant').each((index, fieldset) => {
					const priceUnit = Number.parseFloat($(fieldset).find('input.price:checked').attr('data-price'));
					log('participant ' + index, priceUnit, $(fieldset));
					price += priceUnit;
				});
			}

		} else {
			price = Number.parseFloat($formIndPrice.filter(':checked').attr('data-price'));
		}
		if (isNaN(price)) {
			formValid = false;
		}
		if (!formValid) {
			$totalPrice.hide();
			return;
		}
		$totalPrice.show();
		const formatter = new Intl.NumberFormat('fr-FR', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
		log('calculate_price', price);
		$root.find('#event-subscribe-total-price').text(formatter.format(price));
		if (price > 0) {
			$fieldsetPayment.show();
		} else {
			$fieldsetPayment.hide();
		}
	};

	const $fieldsetPayment = $root.find('fieldset.payment #payment-mode');
	$formMultiAnonymousPrice.on('change', calculate_price);
	$formIndPrice.on('change', calculate_price);
	$root.on('change', 'fieldset.members-participant input.price', calculate_price);

	/**
	 * Desactivate buttons/submit
	 */
		// $root.on('click', 'button', (e) => {
		//   e.preventDefault();
		// });

		// $root.on('submit', 'form', (e) => {
		//   e.preventDefault();
		// });

	const setNewFormType = (type, multiType = def_typeMultiSimple) => {
			log('setNewFormType', type, multiType);
			$formMultiTypeAnonymous.filter('[value="' + multiType + '"]').prop('checked', true);
			$form.attr('data-type', type);
			if (type === def_typeMulti) {
				$form.attr('data-multi-type', multiType);
				if (multiType === def_typeMultiAnonymous) {
					$formMultiAnonymousPrice.first().prop('checked', true);
				} else {
					// $multiMemberQty.val(1).trigger('change');
				}
			} else {
				$multiMemberQty.val(1);
				$formIndPrice.first().prop('checked', true);
				$form.attr('data-multi-type', '');
			}
			calculate_price();
		};

	$menuList.on('click', (e) => {
		e.preventDefault();
		const $menu = $(e.currentTarget);
		setNewFormType($menu.data('type'));
		$menuList.removeClass('active');
		$menu.addClass('active');
		$form.show();
	});

	$formMultiTypeAnonymous.on('change', () => {
		setNewFormType(def_typeMulti, $formMultiTypeAnonymous.filter(':checked').val());
	});

	const checkValidity = (formElement, alertUser = 1) => {
		log('checkValidity', formElement, alertUser);
		const alertUserFct = (e) => {
			if (alertUser === 0) {
				e.preventDefault();
			}
		};
		let isValid = true;
		$(formElement).find('input:visible, select:visible, textarea:visible').each((index, element) => {
			const $element = $(element);
			let elementIsValid = true;
			if ($element.hasClass('is-invalid-custom')) {
				elementIsValid = false;
			}
			$element.on('invalid', alertUserFct);
			if (!element.checkValidity()) {
				elementIsValid = false;
			}
			$element.off('invalid', alertUserFct);
			if (!elementIsValid) {
				if (alertUser) {
					$element.addClass('is-invalid');
					isValid = false;
				}
			} else {
				$element.removeClass('is-invalid');
			}
		});
		if (isValid) {
			$(formElement).closest('fieldset').removeClass('is-invalid');
			if (!$form.find('fieldset.is-invalid:visible').length) {
				$form.removeClass('is-invalid');
			}
		} else {
			$(formElement).closest('fieldset').addClass('is-invalid');
			$form.addClass('is-invalid');
		}
		return isValid;
	};
	$form.find('fieldset').each((index, fieldset) => {
		const checkFieldset = (e) => {
			const $fieldsetValidate = $(e.currentTarget).closest('fieldset');
			checkValidity($fieldsetValidate, 0);
		};
		$(fieldset).on('change', 'input, select, textarea', checkFieldset);
		checkValidity(fieldset, 0);
	});

	const form_is_valid = (alertUser = 1) => {
		let isValid = true;
		if ($form.attr('data-type') === def_typeMultiSimple && alreadyRegistred) {
			if (alertUser === 1) {
				alert('Vous êtes déjà inscrit à cet événement');
			}
			return false;
		}
		$root.find('fieldset').each((index, fieldset) => {
			if (!checkValidity(fieldset, alertUser)) {
				isValid = false;
			}
		});
		return isValid;
	};

	/**
	 * Btn qty
	 */
	$multiMemberQty.on('change', () => {
		const qty = Number.parseInt($multiMemberQty.val(), 10);
		if (qty < 1 || qty > 100) {
			return;
		}
		let changed = true;
		if ($form.attr('data-multi-type') === def_typeMultiSimple) {
			let $fieldsetAll = $root.find('fieldset.members-participant');
			log('$fieldsetAll', $fieldsetAll);
			changed = false;
			let count = Number.parseInt($fieldsetAll.last().attr('data-count'), 10);
			if (qty < $fieldsetAll.length) {
				while (qty < $fieldsetAll.length) {
					// Remove blocks at end
					$fieldsetAll.last().remove();
					changed = true;
					// Recount :
					$fieldsetAll = $root.find('fieldset.members-participant');
					count = Number.parseInt($fieldsetAll.last().attr('data-count'), 10);
				}
			} else {
				while (qty > $fieldsetAll.length) {
					// Add blocks at end
					$formMultiSimpleParticipantModel.clone(true, true).insertAfter($fieldsetAll.last());
					changed = true;
					// Recount :
					$fieldsetAll = $root.find('fieldset.members-participant');
					multiSimpleParticipantEmailSelectApplySelect2($fieldsetAll.last());
					checkValidity($fieldsetAll.last(), 0);
				}
			}
			if (changed) {
				// Renumber them
				$fieldsetAll.each((num, fieldset) => {
					const $fieldset = $(fieldset);
					num += 1;
					$fieldset.find('span.num').text(num);
					if ($fieldset.attr('data-count') === '0') {
						count += 1;
						log('NEW COUNT ', count);
						multiSimpleParticipantRecount($fieldset, count, num);
					}
				});
			}
		}
		if (changed) {
			calculate_price();
		}
	});
	$multiMemberQty.parent().find('.btn-less, .btn-more').on('click', (e) => {
		e.preventDefault();
		const typeMore = $(e.currentTarget).hasClass('btn-more');
		let newQty = Number.parseInt($multiMemberQty.val(), 10);
		newQty += (typeMore ? 1 : -1);
		if (typeMore) {
			const max = Number.parseInt($multiMemberQty.attr('max'), 10);
			if (newQty > max) {
				// alert('Vous ne pouvez pas ajouter plus de ' + max + ' participant(s).');
				$('#modal-alert-message').text('Vous ne pouvez pas ajouter plus de ' + max + ' participant(s).');
				$('#modal-alert').modal('show');
				newQty = max;
			}
		} else {
			const min = Number.parseInt($multiMemberQty.attr('min'), 10);
			if (newQty < min) {
				// alert('Vous devez ajouter au moins ' + min + ' participant.');
				newQty = min;
			}
		}
		log(newQty);
		$multiMemberQty.val(newQty).change();
	});

	/**
	 * multiSimpleParticipant actions
	 */
	const participantAlreadyAdded = (email, $exceptFieldset) => {
		const $fieldsetAll = $root.find('fieldset.members-participant').not($exceptFieldset);
		let found = false;
		$fieldsetAll.each((index, fieldset) => {
			found = ($(fieldset).find('input.multi-participant-delegate-email').val() === email) || ($(fieldset).find('input.multi-participant-email').val() === email);
			if (found) return false;
		});
		return found;
	};
	const multiSimpleParticipantEmailSelect = (e) => {
		const $select = $(e.currentTarget);
		const $fieldset = $select.closest('fieldset.members-participant');
		$fieldset.find('input.multi-participant-email').val($select.val()).trigger('change');
	};
	$root.on('change', 'fieldset.members-participant select.multi-participant-email', multiSimpleParticipantEmailSelect);
	const multiSimpleParticipantEmail = (e) => {
		const $input = $(e.currentTarget);
		const $fieldset = $input.closest('fieldset.members-participant');
		const markPrice = (type, isValid = false) => {
			const $price = $fieldset.find('input.price[value="' + type + '"]').parent();
			if (!isValid) {
				$price.hide();
			} else {
				$price.show();
			}
		};
		log('multiSimpleParticipantEmail', $input.val(), $fieldset);
		// TODO check if not already registred
		//  Get if can have delegate for event
		//  Get if can have member price
		// Reset status
		$input.removeClass('is-valid');
		$input.removeClass('is-invalid');
		$input.removeClass('is-invalid-custom');

		$fieldset.find('.is-delegated input').prop('checked', false);
		$fieldset.removeClass('is-new');
		$fieldset.removeClass('is-membership');
		$fieldset.removeClass('is-delegatable');
		$fieldset.removeClass('is-delegated');
		$fieldset.removeClass('is-exist');
		$fieldset.removeClass('has-delegate');
		$fieldset.removeClass('has-new-delegate');

		markPrice('member');
		markPrice('public');
		markPrice('student');
		markPrice('custom');
		markPrice('custom2');
		markPrice('custom3');
		markPrice('custom4');
		markPrice('custom5');
		markPrice('custom6',true);
		markPrice('custom7',true);
		markPrice('custom8',true);
		markPrice('custom9',true);
		markPrice('custom10',true);

		if (participantAlreadyAdded($input.val(), $fieldset)) {
			$input.parent().find('.invalid-custom').text("Ce participant a déjà été ajouté");
			$input.addClass('is-invalid-custom');
			return;
		}

		// Check email valid
		if (!$input[0].checkValidity()) {
			$input.addClass('is-invalid');
			return;
		}

		// Start ajax
		$input.addClass('loading');
		$input.prop('readonly', true);
		// noinspection JSUnresolvedVariable
		$.ajax({
			url: config.ajaxUrl + '?action=' + config.ajaxCheckEmailAction,
			data: {
				email: $input.val(),
				event_id: eventId,
				nonce: config.ajaxCheckEmailNonce,
			},
			dataType: 'json',
			cache: false,
			method: 'POST',
			complete: () => {
				// Restore ajax
				$input.removeClass('loading');
				$input.prop('readonly', false);
				checkValidity($fieldset, 0);
			},
			error: (jqXHR, textStatus) => {
				// Mark error
				$input.parent().find('.invalid-custom').text("Request failed: " + textStatus);
				$input.addClass('is-invalid-custom');
			},
			success: (data) => {
				log('data', data);
				if (data.error) {
					$input.parent().find('.invalid-custom').text(data.error);
					$input.addClass('is-invalid-custom');
					return;
				}
				$input.addClass('is-valid');
				markPrice('student', true);
				if (!data.registered) {
					$fieldset.addClass('is-new');
					markPrice('public', true);
					markPrice('custom', true);
					markPrice('custom2', true);
					markPrice('custom3', true);
					markPrice('custom4', true);
					markPrice('custom5',true);
					markPrice('custom6',true);
					markPrice('custom7',true);
					markPrice('custom8',true);
					markPrice('custom9',true);
					markPrice('custom10',true);
				} else {
					$fieldset.addClass('is-exist');
					$fieldset.find('.infos-member .name').text(data.first_name + ' ' + data.last_name);
					if (data.membership) {
						$fieldset.addClass('is-membership');
						markPrice('member', true);
					} else {
						markPrice('public', true);
						markPrice('custom', true);
						markPrice('custom2', true);
						markPrice('custom3', true);
						markPrice('custom4', true);
						markPrice('custom5',true);
						markPrice('custom6',true);
						markPrice('custom7',true);
						markPrice('custom8',true);
						markPrice('custom9',true);
						markPrice('custom10',true);
					}
					if (data.is_delegatable) {
						$fieldset.addClass('is-delegatable');
					}
				}
				$fieldset.find('input.price').first().prop('checked');
				calculate_price();
			}

		});
	};
	$root.on('change', 'fieldset.members-participant input.multi-participant-email', multiSimpleParticipantEmail);

	$root.on('keypress', 'fieldset.members-participant input.multi-participant-delegate-email, fieldset.members-participant input.multi-participant-email', (e) => {
		if (e.which === 13) {
			e.preventDefault();
			const $input = $(e.currentTarget);
			$input.trigger('change');
		}
	});
	$root.on('keypress', 'input', (e) => {
		if (e.which === 13) {
			e.preventDefault();
		}
	});
	const multiSimpleParticipantSetDelegated = (e) => {
		const $input = $(e.currentTarget);
		const $fieldset = $input.closest('fieldset.members-participant');
		if ($input.prop('checked')) {
			$fieldset.addClass('has-delegate');
		} else {
			$fieldset.find('input.multi-participant-delegate-email').val('');
			$fieldset.removeClass('has-delegate');
			$fieldset.removeClass('has-new-delegate');
		}
		//has-new-delegate
	};
	$root.on('change', 'fieldset.members-participant .is-delegated input', multiSimpleParticipantSetDelegated);
	const multiSimpleParticipantSetDelegatedEmail = (e) => {
		const $input = $(e.currentTarget);
		const $fieldset = $input.closest('fieldset.members-participant');
		log('multiSimpleParticipantSetDelegated', $input.val(), $fieldset);
		// Reset status
		$input.removeClass('is-valid');
		$input.removeClass('is-invalid');
		$input.removeClass('is-invalid-custom');

		$fieldset.removeClass('has-new-delegate');
		$fieldset.removeClass('has-exist-delegate');

		// noinspection DuplicatedCode
		if (participantAlreadyAdded($input.val(), $fieldset)) {
			$input.parent().find('.invalid-custom').text("Ce participant a déjà été ajouté");
			$input.addClass('is-invalid-custom');
			return;
		}

		// Check email valid
		if (!$input[0].checkValidity()) {
			$input.addClass('is-invalid');
			return;
		}

		// Start ajax
		$input.addClass('loading');
		$input.prop('readonly', true);
		$.ajax({
			url: config.ajaxUrl + '?action=' + config.ajaxCheckEmailAction,
			data: {
				email: $input.val(),
				event_id: eventId,
				nonce: config.ajaxCheckEmailNonce,
			},
			dataType: 'json',
			cache: false,
			type: 'POST',
			complete: () => {
				// Restore ajax
				$input.removeClass('loading');
				$input.prop('readonly', false);
			},
			error: (jqXHR, textStatus) => {
				// Mark error
				$input.parent().find('.invalid-custom').text("Request failed: " + textStatus);
				$input.addClass('is-invalid-custom');
			},
			success: (data) => {
				log('data', data);
				if (data.error) {
					$input.parent().find('.invalid-custom').text(data.error);
					$input.addClass('is-invalid-custom');
					return;
				}
				$input.addClass('is-valid');
				if (!data.registered) {
					$fieldset.addClass('has-new-delegate');
				} else {
					$fieldset.find('.infos-delegate .name').text(data.first_name + ' ' + data.last_name);
					$fieldset.addClass('has-exist-delegate');
				}
			}

		});
	};
	$root.on('change', 'fieldset.members-participant input.multi-participant-delegate-email', multiSimpleParticipantSetDelegatedEmail);

	const multiSimpleParticipantRecount = ($fieldset, count, num) => {
		$fieldset.attr('data-count', count);
		// $fieldset.find('[data-count]').each((index, element) => {
		//   const $element = $(element);
		//   $element.attr('data-count', num);
		// });
		const replaceAttr = (element, attr) => {
			$(element).attr(attr, $(element).attr(attr).replace(/-count[0-9]*/, '-count' + num));
		};
		$fieldset.find('[id*=-count]').each((index, element) => {
			replaceAttr(element, 'id');
		});
		// $fieldset.find('[class*=-count]').each((index, element) => {
		//   replaceAttr(element, 'class');
		// });
		$fieldset.find('[for*=-count]').each((index, element) => {
			replaceAttr(element, 'for');
		});
		$fieldset.find('[name*=-count]').each((index, element) => {
			replaceAttr(element, 'name');
		});
		return $fieldset;
	};
	$root.find('fieldset.members-participant input.price').parent().hide();
	$multiMemberQty.val(1);
	const $formMultiSimpleParticipantModel = multiSimpleParticipantRecount($root.find('fieldset.members-participant').clone(true, true), 0, 0);
	$formMultiSimpleParticipantModel.find('input.multi-participant-email').val('');
	$formMultiSimpleParticipantModel.find('.is-delegated input').prop('checked', false);
	// $formMultiSimpleParticipantModel.find('input').each((i, e) => {
	//   $(e).val('');
	// });
	const multiSimpleParticipantEmailSelectApplySelect2 = ($fieldset) => {
		$fieldset.find('select.multi-participant-email').select2({
			width: 'resolve'
		})
	};
	multiSimpleParticipantEmailSelectApplySelect2($root.find('fieldset.members-participant'));

	/**
	 * Actions on loaded
	 */

	$form.hide();
	const location = document.location.toString();
	if (location.match(/#subscribe-ind/)) {
		$menuList.filter('[data-type="' + def_typeInd + '"]').click().trigger('click');
	} else if (location.match(/#subscribe-multi-anonymous/)) {
		$menuList.filter('[data-type="' + def_typeMulti + '"]').click();
		$formMultiTypeAnonymous.filter('[value="' + def_typeMultiAnonymous + '"]').prop('checked', true).trigger('change');
	} else if (location.match(/#subscribe-multi/)) {
		$menuList.filter('[data-type="' + def_typeMulti + '"]').click();
		$formMultiTypeAnonymous.filter('[value="' + def_typeMultiSimple + '"]').prop('checked', true).trigger('change');
	}

	const validForm = (e) => {
		e.preventDefault();
		const $button = $form.find('button[type="submit"]');
		$button.addClass('loading');
		$button.prop('disabled', true);
		const fntComplete = () => {
			$button.removeClass('loading');
			$button.prop('disabled', false);
		};
		if (!form_is_valid(1)) {
			// alert('Veuillez vérifier la saisie');
			$('#modal-alert-message').text('Veuillez vérifier la saisie.');
			$('#modal-alert').modal('show');
			fntComplete();
			return;
		}
		let formData = new FormData(e.currentTarget);
		formData.append('nonce', config.ajaxCreateNonce);
		formData.append('type', $form.attr('data-type'));
		$.ajax({
			url: config.ajaxUrl + '?action=' + config.ajaxCreateAction,
			data: formData,
			dataType: 'json',
			cache: false,
			processData: false,
			contentType: false,
			type: 'POST',
			error: function (jqXHR, textStatus) {
				// alert(textStatus);
				$('#modal-alert-message').text(textStatus);
				$('#modal-alert').modal('show');
			},
			success: (data) => {
				log(data);
				if (data.error) {
					$('#modal-alert-message').text(data.error);
					$('#modal-alert').modal('show');
				} else {
					const $modalPayment = $('#modal-payment');
					const $modalPaymentBody = $modalPayment.find('.modal-body');
					$modalPaymentBody.html('Chargement en cours...');
					// console.log('href', $from.attr('href'), event);
					$.ajax({
						url: data.redirect_to,
						cache: false,
						method: 'GET',
						dataType: 'json',
						success: (data) => {
							// console.log('data', data);
							$modalPaymentBody.html(data.display);
							window.initPayment();
							$modalPayment.on('hide.bs.modal', function () {
								window.location.href = '/mon-compte/commandes/';
							});
						},
						// error: (jqXHR, textStatus) => {
						// console.log('data error', jqXHR, textStatus);
						// }
					});
					$modalPayment.modal('show');
					// $('#modal-alert-message').text('L\'inscription s\'est terminée avec succès, vous allez être redirigé vers les informations de paiement');
					// $('#modal-alert').modal('show');
					return;
				}
				if (data.redirect_to) {
					window.location = data.redirect_to;
				}
			},
			complete: fntComplete
		});
	};
	$form.on('submit', validForm);

	/* Payment icon management */
	$('.form-field-pay_by .form-field input[type=radio]:checked').parent().addClass('selected');

	$('.form-field-pay_by .form-field input[type=radio]').on('change', function () {
		const selectedPaymentMethod = $(this).val();
		if (selectedPaymentMethod === 'VIR') {
			$('.document').show();
		} else {
			$('.document').hide();
		}
		if (selectedPaymentMethod ==='CHQ') {
			$('.cheque').show();
		} else {
			$('.cheque').hide();
		}
		$('.form-field-pay_by .form-field').removeClass('selected');
		$(this).parent().addClass('selected');

	});
	$('.document').hide();
	$('.cheque').hide();
})
(jQuery, afgcEventSubscribe);
